import { Stack, Tab, Tabs, Typography } from '@mui/material';
import { Provider, type Account } from '@repo/api-gw-sdk';

import { CircleImage } from '@/components/shared/circleImage';
import { useDAL } from '@/contexts/useDAL';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { CloudProviders } from '@/data/inventory/data';

import { AccountJobMetrics } from '../accountJobMetrics';

export const SourceAccountConfigTabs = (props: {
  account: Account;
  onClose: () => void;
}) => {
  const { jobMetricsEnabled } = useFeatureFlags();
  const dal = useDAL();

  return (
    <>
      <Stack className='px-[50px]' direction='row' alignItems='center'>
        {CloudProviders[props.account.cloudProvider] && (
          <CircleImage
            key={props.account.cloudProvider}
            alt={CloudProviders[props.account.cloudProvider]?.displayName}
            src={CloudProviders[props.account.cloudProvider]?.logo}
            className='mr-[8px]'
          />
        )}
        {props.account.providerAccountId}
      </Stack>
      <Tabs value='metrics' className='my-[24px] pl-[40px]'>
        {jobMetricsEnabled && props.account.cloudProvider === Provider.Aws && (
          <Tab
            value={'metrics'}
            key={0}
            label={<Typography variant='subtitle1'>Metrics</Typography>}
          />
        )}
      </Tabs>
      <AccountJobMetrics
        entityDisplayName='Backup'
        account={props.account}
        onClose={props.onClose}
        getMetricConfiguration={() =>
          dal.cloudAccounts.source.metrics.get(props.account.id)
        }
        enableMetrics={async (account, regionName) => {
          await dal.cloudAccounts.source.metrics.enable(account.id, regionName);
        }}
        disableMetrics={async () => {
          await dal.cloudAccounts.source.metrics.disable(props.account.id);
        }}
      />
    </>
  );
};
